import React, { useState, useEffect } from "react";

const Inputs = ({ label, placeholder, type, bg }) => {
  const initialValues = { email: "", password: "" };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate(formValues));
    setIsSubmit(true);
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
    }
  }, [formErrors, isSubmit]);

  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

    // if (!values.username){
    //   errors.username = "Username is required";
    // }

    if (!values.email) {
      errors.username = "Email Address is required";
    } else if (!regex.test(values.email)) {
      errors.email = "Not a valid email format";
    }

    if (!values.password) {
      errors.username = "Password is required";
    } else if (values.password.length < 8) {
      errors.password = "Password must be more than 8 characters";
    }

    return errors;
  };
  return (
    <form onSubmit={handleSubmit}>
      <div className="text-sm w-full">
        <label className="text-border font-semibold">{label}</label>
        <input
          required
          type={type}
          placeholder={placeholder}
          value={formValues}
          onChange={handleChange}
          className={`w-full text-sm mt-2 p-5 text-white border border-border rounded ${
            bg ? "bg-main" : "bg-dry"
          }`}
        />
      </div>
    </form>
  );
};

export default Inputs;
